import FooterComposition from "./FooterComposition";

function Index() {
  return <FooterComposition />;
}

export default Index;
